import { Typography } from "@mui/material";
import { ActiveSessions } from "./ActiveSessions";
import { ConnectedAccounts } from "./ConnectedAccounts";

export function SecurityForm() {
  return (
    <div
      style={{ maxWidth: 680, padding: "26px 28px", borderRadius: 12 }}
      className="w-full bg-white border border-gray-200 shadow-sm"
    >
      <Typography
        variant="h5"
        component="h2"
        className="mb-6 text-gray-900"
        sx={{ fontFamily: "var(--font-crimson)", fontSize: "20px", fontWeight: 400 }}
      >
        Security
      </Typography>

      <ConnectedAccounts />
      <ActiveSessions />
    </div>
  );
}
